import { useEffect, useState } from "react";
import { message } from "antd";
import { collaboratorProfilesApi } from "features/collaborator/api/collaborator-profiles-api";
import { CollaboratorProfileSubordinate } from "features/collaborator/model/collaborator-profile.types";
import { useCurrentUser } from "features/collaborator/hooks/use-current-user";

export const useSubordinates = () => {
  const user = useCurrentUser();
  const [users, setUsers] = useState<CollaboratorProfileSubordinate[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSubordinates = async () => {
      if (!user?.collaborator_profile?.id) return;
      try {
        setLoading(true);
        const data = await collaboratorProfilesApi.getSubordinates(
          user.collaborator_profile.id,
        );
        setUsers(data);
      } catch (error) {
        console.error("Error loading subordinates:", error);
        message.error("Failed to load subordinates");
      } finally {
        setLoading(false);
      }
    };

    loadSubordinates();
  }, [user]);

  return { users, loading };
};
